import React from "react";

import { CardGridBlock as CardGridBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getThemeClass } from "../ThemedModule";
import { Card } from "./Card";

import styles from "./CardGrid.module.scss";

interface CardGridProps {
    value: CardGridBlockValue;
}

export const CardGrid = ({ value }: CardGridProps) => {
    const columns = value.columns || "4";

    return (
        <section
            className={concatClassNames([
                styles.container,
                getThemeClass(value.module_theme),
            ])}
        >
            <div className={styles.grid} data-columns={columns}>
                {value.cards?.map((card) => (
                    <Card key={card.id} value={card.value} />
                ))}
            </div>
        </section>
    );
};
